import React from 'react'
import moment from 'moment'
import formatNumber from '../helpers/formatNumber'
import { useSelector } from 'react-redux'

const TotalCovidCard = (props) => {
  const dataTotal = useSelector(state => state.dataTotal)
  return (
    <>
    <div className="text-secondary text-left mt-5 pt-3 ml-2">Last Update: <h5 style={{fontFamily: 'IBM Plex Mono', color: "black"}}>{moment(dataTotal.lastUpdate).format("dddd, MMMM Do YYYY, h:mm:ss a").toString()}</h5></div>
    <div className="row my-4">
      <div className="col-3">
      <div className="card rounded shadow">
        <div className="card-body text-primary" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(dataTotal.jumlahKasus)}</h1></div>
        <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Terkonfirmasi</strong></div>
      </div>
      </div>
      <div className="col-3">
      <div className="card rounded shadow">
        <div className="card-body text-warning" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(dataTotal.perawatan)}</h1></div>
        <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Dalam Perawatan</strong></div>
      </div>
      </div>
      <div className="col-3">
      <div className="card rounded shadow">
        <div className="card-body text-success" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(dataTotal.sembuh)}</h1></div>
        <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Sembuh</strong></div>
      </div>
      </div>
      <div className="col-3">
      <div className="card rounded shadow">
        <div className="card-body text-danger" style={{fontFamily: 'IBM Plex Mono'}}><h1>{formatNumber(dataTotal.meninggal)}</h1></div>
        <div className="card-footer" style={{backgroundColor: "white", fontSize: '15px'}}><strong>Meninggal</strong></div>
      </div>
      </div>
    </div>
    </>
  )
}

export default TotalCovidCard